import { setEmailSearch } from '../State/emailSearch';

export default (value) => async (dispatch) => {

  dispatch(setEmailSearch(value));
  
}